import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useFirstDeniedConsent } from '../hooks/usePrivacyConsent';
import { ConsentBlocker } from './ConsentBlocker';
export const ConsentPathGuard = ({ service, title, children, testId }) => {
    const firstDenied = useFirstDeniedConsent(service);
    if (firstDenied) {
        return _jsx(ConsentBlocker, { service: firstDenied, title: title, testId: testId });
    }
    return _jsx(_Fragment, { children: children });
};
